<div class="wm-device-details">
  <div class="wm-device-details-table">
    @for (section of detailSections; track section.id) {
      @if (hasSectionContent(section)) {
        <section class="wm-device-details-section">
          <button type="button" class="wm-device-details-section-toggle"
            [attr.aria-expanded]="expandedSections.has(section.id)"
            [attr.aria-controls]="sectionContentId(section)"
            (click)="toggleSection(section.id)">
            <fa-icon [icon]="expandedSections.has(section.id) ? 'chevron-down' : 'chevron-right'" [fixedWidth]="true" aria-hidden="true"></fa-icon>
            <span>{{section.title}}</span>
          </button>

          @if (expandedSections.has(section.id)) {
            <div class="wm-device-details-section-content" [id]="sectionContentId(section)">
              @for (group of section.groups; track group.name) {
                <section class="wm-device-details-group">
                  <button type="button" class="wm-device-details-group-toggle"
                    [attr.aria-expanded]="expandedGroups.has(groupId(group))"
                    [attr.aria-controls]="groupContentId(group)"
                    (click)="toggleGroup(group)">
                    <fa-icon [icon]="expandedGroups.has(groupId(group)) ? 'chevron-down' : 'chevron-right'" [fixedWidth]="true" aria-hidden="true"></fa-icon>
                    <span>{{group.name}}</span>
                  </button>

                  @if (expandedGroups.has(groupId(group))) {
                    <div class="wm-device-details-group-content" [id]="groupContentId(group)">
                      @for (property of group.entries; track property.fullKey) {
                        <div class="wm-device-details-row">
                          <div class="wm-device-details-entry row-desc">
                            <wm-copyable-text [displayText]="property.key" [copyText]="property.fullKey"></wm-copyable-text>
                          </div>
                          @switch (property.fullKey) {
                            @case (DevicePropertyNames.MachineBrowsers) {
                              <div class="wm-device-details-entry">
                                <wm-browsers-info [browsers]="config.browsers"></wm-browsers-info>
                              </div>
                            }
                            @case (DevicePropertyNames.Resolution) {
                              <div class="wm-device-details-entry dict-value">
                                @for (item of $any(property.value) | keyvalue; track item) {
                                  <div class="dict-entry">
                                    <div class="label"><wm-copyable-text [displayText]="$any(item.key)"></wm-copyable-text></div>
                                    <div class="value"><wm-copyable-text [displayText]="prettyPrintDetailValue(item.value)"></wm-copyable-text></div>
                                  </div>
                                }
                              </div>
                            }
                            @case (DevicePropertyNames.ActiveVehicles) {
                              <div class="wm-device-details-entry active-vehicles">
                                @for (vehicle of $any(property.value); track vehicle) {
                                  <wm-browser [displaySmall]="true" [browser]="vehicle.vehicle"></wm-browser>
                                }
                              </div>
                            }
                            @default {
                              @if (isObjectValue(property.value)) {
                                @if (!Array.isArray(property.value)) {
                                  <div class="wm-device-details-entry dict-value">
                                    @for (item of $any(property.value) | keyvalue; track item) {
                                      <div class="dict-entry">
                                        <div class="label"><wm-copyable-text [displayText]="$any(item.key)"></wm-copyable-text></div>
                                        <div class="value"><wm-copyable-text [displayText]="prettyPrintDetailValue(item.value)"></wm-copyable-text></div>
                                      </div>
                                    }
                                  </div>
                                }
                                @if (Array.isArray(property.value)) {
                                  <div class="wm-device-details-entry array-value">
                                    @for (entry of $any(property.value); track entry) {
                                      <div class="dict-value">
                                        @for (item of $any(entry) | keyvalue; track item) {
                                          <div class="dict-entry">
                                            <div class="label"><wm-copyable-text [displayText]="$any(item.key)"></wm-copyable-text></div>
                                            <div class="value"><wm-copyable-text [displayText]="prettyPrintDetailValue(item.value)"></wm-copyable-text></div>
                                          </div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              }
                              @if (!isObjectValue(property.value)) {
                                <div class="wm-device-details-entry">
                                  <wm-copyable-text [displayText]="prettyPrintDetailValue(property.value)"></wm-copyable-text>
                                </div>
                              }
                            }
                          }
                        </div>
                      }
                      @if (group.name === 'webmate' && config.deviceCreator) {
                        <div class="wm-device-details-row">
                          <div class="wm-device-details-entry row-desc"><wm-copyable-text displayText="deployed by"></wm-copyable-text></div>
                          <div class="wm-device-details-entry">
                            <wm-copyable-text [displayText]="config.deviceCreator.name + ', ' + (config.device.creationTime | wmCalendarFormat)"></wm-copyable-text>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </section>
              }

              @if (section.id === 'other' && hasBrowserSessions) {
                <section class="wm-device-details-group">
                  <button type="button" class="wm-device-details-group-toggle"
                    [attr.aria-expanded]="expandedGroups.has(browserSessionsGroupId)"
                    aria-controls="device-details-browser-sessions"
                    (click)="toggleGroupId(browserSessionsGroupId)">
                    <fa-icon [icon]="expandedGroups.has(browserSessionsGroupId) ? 'chevron-down' : 'chevron-right'" [fixedWidth]="true" aria-hidden="true"></fa-icon>
                    <span>Browser Sessions</span>
                  </button>
                  @if (expandedGroups.has(browserSessionsGroupId)) {
                    <div class="wm-device-details-group-content" id="device-details-browser-sessions">
                      @if (config.activeBrowserSession) {
                        <div class="wm-device-details-row">
                          <div class="wm-device-details-entry row-desc">Active browser session:</div>
                          <div class="wm-device-details-entry session-entry">
                            <button pButton class="p-button-text custom-label" (click)="openBrowserSessionViewer(config.activeBrowserSession.id)">Show Session</button>
                            <button pButton class="p-button-text custom-label danger" (click)="stopExpedition(config.activeBrowserSession.id)">Stop Session</button>
                            <span><span class="label">started:</span> {{config.activeBrowserSession.optStart | wmCalendarFormat}}</span>
                          </div>
                        </div>
                      }
                      @for (session of config.oldBrowserSessions; track session.id; let first = $first) {
                        <div class="wm-device-details-row">
                          <div class="wm-device-details-entry row-desc">{{first ? 'Previous browser sessions:' : ''}}</div>
                          <div class="wm-device-details-entry session-entry">
                            <button pButton class="p-button-text custom-label" (click)="openBrowserSessionViewer(session.id)">Show Session</button>
                            <span><span class="label">started:</span> {{session.optStart | wmCalendarFormat}} <span class="label">ended:</span> {{session.optEnd | wmCalendarFormat}}</span>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </section>
              }
            </div>
          }
        </section>
      }
    }
  </div>
</div>
